/* eslint-disable @next/next/no-img-element */
"use client";

import React, { useRef } from "react";
import ImageEditor, { ImageEditorRef } from "@/components/molecules/ImageCanvas";
import { Button } from "@/components/ui/button";
import { ImageDTO } from "@/types";
import { Modal } from "components/atoms/Modal";
interface CanvasModalProps {
  isOpen: boolean;
  imageDto: ImageDTO;
  onMaskSubmit: (maskDataUrl: string | null) => void;
  onClose: () => void;
}
const CanvasModal: React.FC<CanvasModalProps> = ({
  isOpen,
  imageDto,
  onMaskSubmit,
  onClose
}) => {
  const editorRef = useRef<ImageEditorRef>(null);
  const handleSubmit = () => {
    if (editorRef.current) {
      const maskDataUrl = editorRef.current.getMask();
      onMaskSubmit(maskDataUrl);
    }
    onClose();
  };
  return <Modal open={isOpen} handleBackdropClick={onClose} disableBackdropClick data-sentry-element="Modal" data-sentry-component="CanvasModal" data-sentry-source-file="index.tsx">
            <div className="bg-gray-900 p-6 rounded-lg max-w-3xl mx-auto">
                <h2 className="text-2xl text-white font-semibold mb-4 text-center">
                    Edit Mask
                </h2>
                <div className="mb-4">
                    <ImageEditor ref={editorRef} imageUrl={imageDto.image} data-sentry-element="ImageEditor" data-sentry-source-file="index.tsx" />
                </div>
                <div className="flex justify-end space-x-4">
                    <Button variant="outline" onClick={onClose} className="text-white border-gray-500" data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} className="bg-emerald-600 hover:bg-emerald-700 text-white" data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        Submit
                    </Button>
                </div>
            </div>
        </Modal>;
};
export default CanvasModal;